import React from 'react'
import { Heading } from '@chakra-ui/react'

function SectionHeading(props) {
  return (
    <Heading
      color="inherit"
      fontFamily="body"
      fontSize="md"
      letterSpacing="2px"
      mb={9}
      textTransform="uppercase"
      {...props}
    >
      {props.children}
    </Heading>
  )
}

export default SectionHeading
